
import React from "react"
import { IIconProps } from "./Icon/Interfaces"

const ArrowUpRoundedIcon = ({
	width = 12,
	height = 8,
  strokeColor='var(--blue)',
}: IIconProps) => {
	return (
    <svg viewBox="0 0 12 8" width={width} height={height} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.019.51a1 1 0 0 1 1.531 0l4.783 5.694a1 1 0 0 1-.766 1.644H1.002a1 1 0 0 1-.766-1.644L5.02.51Z" fill={strokeColor} />
    </svg>
	)
}

export default ArrowUpRoundedIcon
